export const AuthenticationTexts = {
  ConsentsScreen: {
    title: 'Нужно ваше согласие, чтобы мы могли отправить вам документы по займу',
    buttonText: 'Продолжить',
  },
  InitialScreen: {
    title: 'Войдите, чтобы продолжить',
    buttonText: 'Продолжить',
  },
  OtpScreen: {
    title: 'Войдите, чтобы продолжить',
    buttonText: 'Продолжить',
  },
};
